import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaQuoteLeft, FaGraduationCap } from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ServiceCrossNav from '../components/ServiceCrossNav';
import './ServicePage.css';
import './Formation.css';

// Logos des partenaires académiques et professionnels
import inau from '../assets/INAU.png';
import ehtp from '../assets/EHTP.png';
import mastere from '../assets/MASTERE INGENIERIE IMMO.jpg';
import onigt from '../assets/Logo Onigt.JPG';
import welearn from '../assets/WELEARN.jpg';
import timlog from '../assets/TIMLOG.png';
import reaconsult from '../assets/REACONSULT.png';

const partners = [
  { id: 1, img: inau, name: 'INAU' },
  { id: 2, img: ehtp, name: 'EHTP' },
  { id: 3, img: mastere, name: 'Mastère Ingénierie Immobilière' },
  { id: 4, img: onigt, name: 'ONIGT' },
  { id: 5, img: welearn, name: 'WELEARN' },
  { id: 6, img: timlog, name: 'TIMLOG SOLUTIONS' },
  { id: 7, img: reaconsult, name: 'REA CONSULT' },
];

const Formation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Formation Immobilière au Maroc | ATAA REALTY (INAU, EHTP, IAV)"
        description="Formation immobilière au Maroc en collaboration avec INAU, EHTP, IAV Hassan II, ONIGT et plateformes professionnelles. Encadrement académique et partage du savoir par ATAA REALTY."
        canonical="https://ataarealty.com/services/formation"
        keywords="formation immobilière Maroc, formation expertise immobilière, mastère ingénierie immobilière EHTP, INAU formation, formation continue immobilier"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Formation Immobilière',
          provider: { '@type': 'ProfessionalService', name: 'ATAA REALTY', url: 'https://ataarealty.com/' },
          areaServed: { '@type': 'Country', name: 'Maroc' },
          description: "Formation immobilière au Maroc : encadrement académique, interventions et collaborations avec INAU, EHTP, IAV Hassan II, ONIGT, WELEARN, TIMLOG et REA CONSULT.",
          serviceType: "Formation immobilière, encadrement académique, séminaires professionnels",
          url: 'https://ataarealty.com/services/formation'
        }}
      />
      <Navbar />

      {/* HERO */}
      <header className="svc-header svc-bg-formation">
        <div className="svc-overlay"></div>
        <div className="container svc-title-box svc-anim-up">
          <span className="svc-eyebrow">Partage du Savoir</span>
          <h1>Formation</h1>
        </div>
      </header>

      <section className="svc-content">
        <div className="container">
          {/* INTRO — meaning of ATAA */}
          <div className="svc-section svc-anim-up svc-delay-1">
            <div className="formation-meaning">
              <FaQuoteLeft className="formation-quote-icon" />
              <p className="formation-meaning-text">
                <strong>ATAA</strong> étant un mot qui signifie{' '}
                <em>donner</em>, c'est dans ce sens que la formation occupe une
                place à part au sein de <strong>ATAA REALTY</strong>.
              </p>
            </div>

            <p>
              Au-delà des missions d'expertise, d'études ou de conseil, le
              cabinet s'inscrit dans une démarche de{' '}
              <strong>partage du savoir immobilier</strong>, où l'expérience de
              terrain, les référentiels professionnels et la réflexion
              académique sont mis en commun au service de celles et ceux qui
              apprennent, pratiquent et construisent le secteur.
            </p>

            <p>
              Cette action prend forme à travers les interventions de la
              direction du cabinet en tant qu'enseignant et encadrant de travaux
              et de mémoires, ainsi que par des collaborations avec des
              institutions et des acteurs de la formation, académiques et
              professionnels.
            </p>
          </div>

          {/* PARTENAIRES — text mention */}
          <div className="svc-section svc-anim-up svc-delay-2">
            <h2 className="svc-section-title">
              Nos Collaborations Académiques &amp; Professionnelles
            </h2>
            <p>
              Parmi les institutions et structures avec lesquelles nous
              collaborons figurent notamment :
            </p>

            <div className="formation-partners-text">
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span><strong>INAU</strong> – Institut National d'Aménagement et d'Urbanisme</span>
              </div>
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span>
                  <strong>EHTP / WELEARN –</strong> – Mastère en Ingénierie Immobilière
                </span>
              </div>
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span><strong>IAV Hassan II</strong> – Institut Agronomique et Vétérinaire</span>
              </div>
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span>
                  <strong>ONIGT</strong> – Ordre National des Ingénieurs Géomètres Topographes
                </span>
              </div>
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span><strong>TIMLOG SOLUTIONS</strong> – Cabinet de formation</span>
              </div>
              <div className="formation-partner-item">
                <FaGraduationCap />
                <span><strong>REA CONSULT</strong> – Cabinet de conseil et formation</span>
              </div>
            </div>
          </div>

          {/* PARTENAIRES — logo grid */}
          <div className="svc-section svc-anim-up svc-delay-3">
            <h3 className="formation-logo-title">Ils nous font confiance</h3>
            <div className="formation-logos-grid">
              {partners.map((p) => (
                <div
                  key={p.id}
                  className={`formation-logo-box${
                    p.name === 'ONIGT' ? ' formation-logo-box--zoom' : ''
                  }`}
                >
                  <img src={p.img} alt={p.name} />
                </div>
              ))}
            </div>
          </div>

          {/* CLOSING — philosophy */}
          <div className="svc-section svc-anim-up svc-delay-3">
            <div className="formation-closing">
              <p>
                <strong>Former</strong>, pour ATAA REALTY, ce n'est pas
                transmettre des réponses, mais{' '}
                <span className="formation-highlight">
                  partager des méthodes, des repères et des manières de raisonner
                </span>
                , afin que chacun puisse, à son tour, produire des décisions
                plus justes et des pratiques plus responsables.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="svc-cta-section">
        <h3>Une demande de formation ou d'intervention ?</h3>
        <p>
          Modules sur mesure, séminaires institutionnels, encadrement
          académique : échangeons sur vos besoins en formation immobilière.
        </p>
        <Link to="/contact" className="svc-cta-btn">
          Nous contacter <FaArrowRight />
        </Link>
      </section>

      <ServiceCrossNav currentSlug="formation" />

      <Footer />
    </>
  );
};

export default Formation;
